var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 6.00016C1.86368 6.00016 2.37239 6.21088 2.74747 6.58595C3.12254 6.96102 3.33325 7.46973 3.33325 8.00016C3.33325 8.5306 3.12254 9.0393 2.74747 9.41438C2.37239 9.78945 1.86368 10.0002 1.33325 10.0002V11.3335C1.33325 11.6871 1.47373 12.0263 1.72378 12.2763C1.97382 12.5264 2.31296 12.6668 2.66659 12.6668H13.3333C13.6869 12.6668 14.026 12.5264 14.2761 12.2763C14.5261 12.0263 14.6666 11.6871 14.6666 11.3335V10.0002C14.1362 10.0002 13.6274 9.78945 13.2524 9.41438C12.8773 9.0393 12.6666 8.5306 12.6666 8.00016C12.6666 7.46973 12.8773 6.96102 13.2524 6.58595C13.6274 6.21088 14.1362 6.00016 14.6666 6.00016V4.66683C14.6666 4.31321 14.5261 3.97407 14.2761 3.72402C14.026 3.47397 13.6869 3.3335 13.3333 3.3335H2.66659C2.31296 3.3335 1.97382 3.47397 1.72378 3.72402C1.47373 3.97407 1.33325 4.31321 1.33325 4.66683V6.00016Z",
    stroke: "#0F3D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 3.3335V4.66683",
    stroke: "#0F3D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 11.3335V12.6668",
    stroke: "#0F3D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 7.3335V8.66683",
    stroke: "#0F3D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.d788c05e8faeb8e87236709abf412d14.svg";
export { ForwardRef as ReactComponent };